import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "src/apps/providers/AuthProvider";
import { SearchParamsProvider } from "src/apps/providers/SearchParamsProvider";
import { appDependencies } from "./AppDependencies";
import { AppDependenciesProvider } from "./providers/AppDependenciesProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { staticAppDependencies } from "./StaticAppDependencies";
import { Navigation } from "./routes/Navigation";
import { registerLocale } from "i18n-iso-countries";
import countriesCA from "i18n-iso-countries/langs/ca.json";
import countriesEN from "i18n-iso-countries/langs/en.json";
import countriesES from "i18n-iso-countries/langs/es.json";
import countriesEU from "i18n-iso-countries/langs/eu.json";
import countriesPT from "i18n-iso-countries/langs/pt.json";
import countriesFR from "i18n-iso-countries/langs/fr.json";
import countriesIT from "i18n-iso-countries/langs/it.json";
import { TranslationsProvider } from "./providers/TranslationsProvider";
import { AuthEnvironmentGate } from "./routes/AuthEnvironmentGate";
import { CustomizationProvider } from "./providers/CustomizationProvider";
import mixpanel from "mixpanel-browser";

registerLocale(countriesES);
registerLocale(countriesEU);
registerLocale(countriesPT);
registerLocale(countriesCA);
registerLocale(countriesEN);
registerLocale(countriesFR);
registerLocale(countriesIT);

mixpanel.init(`${process.env.MIXPANEL_TOKEN}`, {
  api_host: "https://api-eu.mixpanel.com",
  record_sessions_percent: 1,
  record_heatmap_data: true,
  record_mask_text_selector: "",
});

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, staleTime: 100 } },
});

const appDeps = process.env.STATIC_DEPS ? staticAppDependencies() : appDependencies();

export default function App() {
  return (
    <BrowserRouter basename={process.env.APP_BASE_PATH || "/"}>
      <QueryClientProvider client={queryClient}>
        <AppDependenciesProvider
          documentationAreaController={appDeps.documentationAreaController}
          translationController={appDeps.translationController}
          authController={appDeps.authController}
        >
          <SearchParamsProvider>
            <AuthProvider>
              <AuthEnvironmentGate>
                <TranslationsProvider>
                  <CustomizationProvider>
                    <Navigation />
                  </CustomizationProvider>
                </TranslationsProvider>
              </AuthEnvironmentGate>
            </AuthProvider>
          </SearchParamsProvider>
        </AppDependenciesProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
